/*
 * Models for storing survey labels in multiple language
 */

define([
  "backbone",
  "underscore",
  "jquery",
  "messaging/messenger",
  "configuration/properties",
], function (Backbone, _, $, Messenger, Properties) {
  var SurveyLabelsModel = {};

  //client-side Model representation of the SurveyLabel object.
  SurveyLabelsModel.surveyLabel = Backbone.Model.extend({
    idAttribute: "starRating",
    defaults: {
      starRating: 0,
      label: "",
    },
    defaultValidateAttributes: ["label"],
    validateAttribute: function (attribute, value) {
      if (attribute === "label") {
        return this.validateRequiredValue(value, { maxLength: 255 });
      }
    },
  });

  //Survey labels for a single language and touchpoint
  SurveyLabelsModel.surveyLabels = Backbone.Model.extend({
    idAttribute: "languageId",
    defaults: function () {
      var defaults = {
        languageId: 0,
        touchPointId: 0,
      };
      return defaults;
    },
    parse: function (rawResponse) {
      //create models for each survey label and store it in a basic collection
      this.createSurveyLabels(rawResponse.surveyLabels);
      //add in any missing labels
      return rawResponse;
    },
    createSurveyLabels: function (rawModels) {
      this.surveyLabels = new Backbone.Collection(null, {
        model: SurveyLabelsModel.surveyLabel,
        comparator: "starRating",
      });
      if (rawModels) {
        this.surveyLabels.add(rawModels);
      }
      this.generateMissingLabels();
    },
    getSurveyLabels: function () {
      return this.surveyLabels;
    },
    generateMissingLabels: function () {
      //loop through each rating and add a label model to the collection.  If one already exists, the add will be ignored.
      for (var rating = 1; rating <= 5; rating++) {
        this.surveyLabels.add({ starRating: rating });
      }
    },
    saveModel: function (options) {
      //generate a new surveyLabels attribute based off of the surveyLabels collection.  Remove any empty labels
      const newSurveyLabels = this.surveyLabels
        .map(function (label) {
          return label.attributes;
        })
        .filter(function (l) {
          return l.label.length > 0;
        });
      this.set("surveyLabels", newSurveyLabels);
      const modelOptions = this._prepareSaveModelOptions(options);
      //only care if the model is dirty and has labels.  We don't check isNew() since we create new placeholder
      // models
      if (this.dirty && newSurveyLabels.length > 0) {
        //call default save function with options
        return this.save(null, modelOptions);
      } else {
        //fire success callback because nothing needed to be saved
        modelOptions.success(this, {}, options);
      }
    },
    url: function () {
      var kbId = Messenger.reqres.request("active:kb");
      return (
        Properties.rootURL +
        "/" +
        kbId +
        "/survey/labels/language/" +
        this.id +
        "/touchpoint/" +
        this.get("touchPointId")
      );
    },
  });

  //Collection of survey labels for every language in the KB
  SurveyLabelsModel.surveyLabelsCol = Backbone.Collection.extend({
    model: SurveyLabelsModel.surveyLabels,
    addLabels: function (languageId, touchPointId) {
      var newModel = this.add({ languageId: languageId, touchPointId: touchPointId });
      newModel.createSurveyLabels();
      return newModel;
    },
    url: function () {
      var kbId = Messenger.reqres.request("active:kb");
      return Properties.rootURL + "/" + kbId + "/survey/labels/touchpoint/" + this.touchPointId;
    },
  });

  Messenger.reqres.setHandler(
    "survey:labels",
    function (touchPointId) {
      var labels = new SurveyLabelsModel.surveyLabelsCol();
      labels.touchPointId = touchPointId;
      labels.fetch();
      return labels;
    },
    this,
  );

  return SurveyLabelsModel;
});
